import React from 'react';
import { Modal } from 'antd';
import { DeleteOutlineRounded } from '@mui/icons-material';

interface ConfirmDeleteModalProps {
	itemName: string;
	onConfirm: () => void;
	onCancel?: () => void;
	title?: string;
	content?: string;
	okText?: string;
	cancelText?: string;
	icon?: React.ReactNode;
	okButtonProps?: Record<string, any>;
	closable?: boolean;
	maskClosable?: boolean;
}

const showConfirmDeleteModal = ({
	itemName,
	onConfirm,
	onCancel,
	title = 'Are you sure you want to delete this item?',
	content,
	okText = 'Delete',
	cancelText = 'Cancel',
	icon = <DeleteOutlineRounded className="text-red-500 mr-2" />,
	okButtonProps = { danger: true, type: 'primary', className: 'hover:bg-red-600' },
	closable = false,
	maskClosable = true,
}: ConfirmDeleteModalProps) => {
	const defaultContent = `${itemName} will be permanently deleted.`;

	Modal.confirm({
		icon,
		title,
		content: content || defaultContent,
		okButtonProps: { ...okButtonProps, 'data-testid': 'confirm-delete-modal-button' },
		okText,
		cancelText,
		onOk: onConfirm,
		onCancel,
		closable,
		maskClosable,
		className: 'confirm-delete-modal',
	});
};

export default showConfirmDeleteModal;
